import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n                    <li>\n                        <rv-navlink\n                            ref=", "\n                            .item=", "\n                            .number=", "\n                        ></rv-navlink>\n                    </li>\n                "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n            <ol class=", ">\n                ", "\n            </ol>\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { Component, html } from 'lib/component';
import { ref } from 'lib/lit-ref';
import store from 'lib/store';
import * as styles from './styles';
import anime from 'animejs';

const mediator = require('tiny-emitter/instance');

export default class Nav extends Component {
  init() {
    this.current = -1;
    this.isVisible = false;
  }

  render() {
    return html(_templateObject(), styles.list, store.get('content').nav.map((item, i) => html(_templateObject2(), ref(this, 'items'), item, 1 + i)));
  }

  onRender() {
    this.classList.add(styles.nav);
    this.classList.add('u-hidden');
    mediator.on('route', this.onRoute, this);
  }

  onRoute(route, event) {
    let index = store.get('content').nav.findIndex(item => item.url == route);
    if (route == 'home') index = 0;
    this.show(index);
    if (!this.isVisible) this.enter();
  }

  show(index) {
    // if (this.current == index) return
    let prev = this.refs.items[this.current];

    if (prev) {
      prev.leave();
    }

    if (index < 0) return;
    this.refs.items[index].enter();
    this.current = index;
  }

  animateIn(params, complete) {
    this.isVisible = true;
    anime({
      targets: this.refs.items,
      opacity: [0, 1],
      translateY: [10, 0],
      easing: 'easeOutQuart',
      duration: 1200,
      delay: anime.stagger(80, {
        start: 2000
      }),
      begin: () => {
        this.classList.remove('u-hidden');
      },
      complete
    });
  }

  animateOut(params, complete) {
    complete && complete();
  }

}
customElements.define('rv-nav', Nav);